import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.PERFORMANCE_TESTING)

const TESTING_LIFECYCLE = ['Baseline', 'Simulate', 'Measure', 'Analyse', 'Optimise', 'Validate']
const WHAT_WE_TEST = [
  {title: 'Load Testing',desc:'Understand how your application performs under expected user and transaction volumes.'},
  {title: 'Stress Testing',desc:'Push the application beyond normal operating conditions to identify breaking points and recovery behaviour.'},
  {title: 'Scalability Testing', desc:'Determine how effectively the application handles increasing users, workloads, and data.'},
  { title: 'Response Time & Throughput',desc:'Measure application response times, transaction throughput, and overall system responsiveness.'},
  { title: 'Database & API Performance',desc:'Identify bottlenecks across database queries, APIs, integrations, and backend services.'},
  { title: 'Endurance Testing',desc:'Evaluate application stability during prolonged periods of sustained activity.'},
]

const STACK_BADGES = [ 
  // Middle — 4 badges, 90° apart
  { label: 'Speed', tier: 'middle', angle: 0   },
  { label: 'Scalability', tier: 'middle', angle: 70  },
  { label: 'Stability', tier: 'middle', angle: 140 },
  { label: 'Stress', tier: 'middle', angle: 210 },
  { label: 'Capacity', tier: 'middle', angle: 280 },
]

// const TIER_SIZE = { inner: '44%', middle: '72%', outer: '100%' }
const TIER_SIZE = {
  inner: '48%',
  middle: '76%',
  outer: '100%',
}
// Inner orbits slowest, outer fastest — matches how real orbital motion looks.
const TIER_DURATION = { inner: 44, middle: 26, outer: 16 } // seconds

export default function PerformanceTesting() {
  

  return (
    <>
    {/* <MetaInfo
    title="Performance Testing | CruxBytes"
    description="Measure application speed, scalability, stability, and reliability with performance, load, stress, and scalability testing services."
    keywords="performance testing, load testing, stress testing, scalability testing, endurance testing, application performance, QA services, CruxBytes"
   /> */}
    <MetaInfo
      title={`${label} ${SITE.metaTagPostText}`} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Software Testing & QA -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Performance Testing */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Identify vulnerabilities and strengthen applications through rigorous performance testings. */}
             {pageDesc}
             </p>
            
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
           {/* Section 1 */}
         
                 <section className="section-py bg-linear-gradient-light"  aria-labelledby="on-demand-intro-heading">
                   <div className="container">
                     <div className="section-header pt-4" data-aos="fade-up">                       
                       <p className="text-center">
                         An application may work perfectly with a few users and behave very differently when traffic, transactions, or data volumes increase.
                       </p>
                       <p className="text-center">
                         CruxBytes uses performance testing to evaluate application speed, stability, scalability, and responsiveness under realistic and demanding conditions—helping you identify bottlenecks before they impact users. Our efficient team of experts ensure that our performance testing results do not increase your infrastructure costs but ensure optimal performance for your applications and softwares even at the peak levels.
                       </p>                       
                     </div>
                   </div>
                 {/* </section>

<section className="section-py bg-peach "> */}
    <div className="container ">
      
       <div className="on-demand-split no-gap">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" >
           <div className="">
           
  <ul className="check-list ps-0">
     <h5>What We Evaluate</h5>
    {WHAT_WE_TEST.map((card, i) => (
      <li
        key={card.title}
        data-aos="fade-up"
        data-aos-delay={(i % 3) * 80}
      >
        {/* <i className="fa-solid fa-circle-check check-list-icon" aria-hidden="true" /> */}
        {/* <i className="fa-regular fa-thumbs-up check-list-icon" aria-hidden="true" /> */}
        <i className="fa-regular fa-star check-list-icon" aria-hidden="true" />
        <div>
          <h6 className="mb-0">{card.title}</h6>
          <p className="wcs-desc">{card.desc}</p>
        </div>
      </li>
    ))}
  </ul>
</div>
              
        </div>
        {/* ── RIGHT:  ── */}
        <div   data-aos="fade-left">  
         <div className="pf-orbit-wrap m-0" data-aos="fade-left">
         
        <div className="stack-orbit" data-aos="fade-left">
          {/* <span className="stack-ring testing-ring stack-ring--1" aria-hidden="true" /> */}
          <span className="stack-ring testing-ring stack-ring--2" aria-hidden="true" />
          <span className="stack-ring  testing-ring stack-ring--3" aria-hidden="true" />
          <span className="stack-testing-center-pill">Can it handle<br/>the load?</span>
          {STACK_BADGES.map((badge) => (
            <span
              key={badge.label}
              className="stack-orbit-track"
              style={{
                width: TIER_SIZE[badge.tier],
                height: TIER_SIZE[badge.tier],
                '--start-angle': `${badge.angle}deg`,
                animationDuration: `${TIER_DURATION[badge.tier]}s`,
              }}
            >
              <span className="stack-badge" style={{ animationDuration: `${TIER_DURATION[badge.tier]}s` }}>
                {/* <badge.Icon />  */}
                {badge.label}
              </span>
            </span>
          ))}
        </div>
        </div>
        </div>
      </div>
    </div>
</section>
      {/* Section 3 */}
         <section className="section-py ">
                <div className="container ">
        <div className="on-demand-split">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
        
          <div className="cp-timeline-header">
            <h2 >Find the Bottleneck Before Your Users Do</h2>
            <p >
            We analyse performance across the application stack to identify resource constraints, inefficient processes, database issues, API bottlenecks, and infrastructure limitations.
            </p>            
            <p>
               Performance testing provides the insight needed to improve application reliability, plan capacity, and create a technology foundation that can handle real-world usage and future growth.
            </p>
          </div>     

        </div>
                {/* ── RIGHT:  ── */}
        <div   data-aos="fade-left">  
          <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
            <h6>Built to Perform When Demand Grows</h6>
            <ol className="step-flow mt-4" role="list" aria-label="Testing lifecycle">
              {TESTING_LIFECYCLE.map((step) => (
                <li key={step} className="step-flow-item">
                  <span className="step-flow-label" style={{fontSize:'var(--fs-xs)'}}>{step}</span>
                </li>
              ))}
            </ol>
            
            
          </div>
        </div>
        </div>   
      </div>                
         </section>
         <TransformBanner />
         </main>
         </>
  )
}